import {AccessRole} from "enums/accessRole";
import {en} from "language/en";

export const ACCESS_ROLE_LABEL = {
  [AccessRole.User]: en.common.label.user,
  [AccessRole.PowerUser]: en.common.label.powerUser,
  [AccessRole.Admin]: en.common.label.admin,
  [AccessRole.Owner]: en.common.label.owner,
  [AccessRole.Guest]: en.common.label.guest,
}